import { IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar } from '@ionic/react';
import { useLocation, useParams } from 'react-router';
import CreateBuyerSupplier from '../../components/buyerSupplier/CreateBuyerSupplier';
import ViewBuyers from '../../components/buyerSupplier/ViewBuyers';
import ViewBuyersV2 from '../../components/buyerSupplier/ViewBuyersV2';
import ViewSuppliers from '../../components/buyerSupplier/ViewSuppliers';
import CreateOrganization from '../../components/CreateOrganization';
import ViewBuyersV3 from '../../components/buyerSupplier/ViewBuyersV3';

const ViewBuyersPage: React.FC = () => {

  const { name } = useParams<{ name: string; }>();
  let orgPageTitle = '';
  console.log(name);
  const location = useLocation();
  console.log(location.pathname);
  if (location.pathname.includes("create-supplier")) {
    orgPageTitle = "Supplier";
  } else if (location.pathname.includes("create-buyer")) {
    orgPageTitle = "Buyer";
  } else {
    orgPageTitle = "organization";
  }
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color="primary">
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>
          <IonTitle>Create {orgPageTitle}</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen>
        <IonHeader collapse="condense">
          <IonToolbar color="primary">
            <IonTitle size="large">Create {orgPageTitle}</IonTitle>
          </IonToolbar>
        </IonHeader>
        {/* <ViewBuyers name={''}></ViewBuyers> */}
        {/* <ViewBuyersV2 name={orgPageTitle} /> */}
        <ViewBuyersV3 name={orgPageTitle} />
      </IonContent>
    </IonPage>
  );
};

export default ViewBuyersPage;
